module.exports = __webpack_public_path__ + "static/img/14.291f891.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/14.png
// module id = YVc/
// module chunks = 0